import React, { useEffect, useMemo } from "react";
import { TableStore } from "src/components/tables/TableStore";
import { Empty, Modal } from "antd";
import { RetweetOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { EntityStates } from "src/pages/EntityCardPage/EntityFormWithAnchor/EntityStates";
import { t } from "i18next";
import { StateView } from "src/components/StateView";
import { DropdownChildButton } from "src/components/buttons/DropdownChildButton";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { EntityFilters, ZEntityRow } from "../types";
import { ChangeStateBulkStore } from "./ChangeStateBulkStore";

interface PropsChangeStateBulkButton {
  tableStore: TableStore<ZEntityRow, EntityFilters>;
  objectId: ZUid;
  attributes: ZAttribute[];
  onLoad?: (flag: boolean) => void;
}

export const ChangeStateBulkButton: React.FC<PropsChangeStateBulkButton> =
  observer(({ tableStore, objectId, attributes, onLoad }) => {
    const store = useMemo(
      () => new ChangeStateBulkStore(tableStore, objectId, attributes, onLoad),
      [tableStore, objectId, attributes],
    );
    useEffect(() => {
      store.init();
    }, [store]);

    const { curStateName, wrong, hasNextSteps, stateOptions, attrNamesMap } =
      store;
    const curStateView = curStateName ? (
      <StateView name={curStateName} />
    ) : undefined;

    return (
      <>
        <DropdownChildButton
          onClick={() => {
            store.onStart();
          }}
          disabled={wrong}
          icon={<RetweetOutlined />}
        >
          {t("Change of state")}
        </DropdownChildButton>
        <Modal
          title={t("ChangingTheStateOfAnInstance", { count: 0 })}
          open={!!stateOptions}
          onCancel={() => store.setStateOptions(null)}
          footer
        >
          {hasNextSteps ? (
            <EntityStates
              currentState={curStateView}
              stateOptions={stateOptions ?? []}
              onFinish={(stateId) => store.onFinish(stateId)}
              attrNamesMap={attrNamesMap}
            />
          ) : (
            <Empty description={t("No available states for transition")} />
          )}
        </Modal>
      </>
    );
  });
